import axios from 'axios'

export type LinkAttachmentRefreshResponse = {
  attachment_id: number
  url: string
  summary?: string | null
  title?: string | null
  updated_at?: string | null
}

export function refreshLinkAttachment(attachmentId: number) {
  return axios
    .post<LinkAttachmentRefreshResponse>(`/api/link-attachments/${attachmentId}/refresh`)
    .then((res) => res.data)
}

export function deleteLinkAttachment(attachmentId: number) {
  return axios.delete(`/api/link-attachments/${attachmentId}`)
}
